import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=1cf4b6c5&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"
import style0 from "./Wallet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=1cf4b6c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4b6c5",
  null
  
)

export default component.exports